<template>
  <div v-if="!loading">
    <base-shell
      :title="pageMeta.title"
      :description="pageMeta.description"
      :hideSidebar="shouldHideSidebar"
    >
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view>
    </base-shell>

    <van-popup safe-area-inset-bottom style="background: transparent;" v-model="show">
      <div :class="isActivity ? 'vip15day' : ''" class="vipimgbox">
        <img v-if="isActivity" style="width: 330px" src="@/assets/img/vip1.png" alt="" />
        <img v-else-if="vipPost" style="width: 330px" src="@/assets/img/vipPost.png" alt="" />
        <img v-else style="width: 330px" src="@/assets/img/vip3days.png" alt="" />
        <div @click.stop="backvip" class="btn"></div>
        <div @click.stop="show = false" class="close"></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import axios from 'axios';
import { wxuser, getFreeVip, getFreeFTVip, yichenLoginEx } from '@/api/base';
import { setFormateDateEnd } from '@/utils/index';
import BaseShell from './BaseShell.vue';
import { getPcPageMeta } from './utils';
export default {
  name: 'PcMain',
  components: {
    BaseShell,
  },
  data() {
    return {
      loading: false,
      show: false,
      isActivity: this.$store.state.app.isActivity,
      vipPost: false,
      userinfo: {},
    };
  },
  computed: {
    pageMeta() {
      return getPcPageMeta(this.$route);
    },
    shouldHideSidebar() {
      return this.$route.path === '/plate/list';
    },
  },
  watch: {
    $route() {
      this.isDialogShow();
    },
  },
  beforeCreate() {
    // PC 和移动端共用同一份广告数据，避免页面内部取值为空。
    axios.get('/ad/ad.json').then(response => {
      this.$store.commit('setAdBanner', response.data);
    });
  },
  created() {
    if (this.$route.path != '/posts') {
      this.getUserinfo();
    }
  },
  methods: {
    getUserinfo() {
      this.loading = true;
      wxuser().then(res => {
        res.data.wxUser.isVip = 0;
        const now = new Date().getTime() / 1000;

        res.data.vipInfos.map(item => {
          if (item.vipType == 1 && now < new Date(item.validityTime).getTime() / 1000) {
            res.data.wxUser.isVip = 1;
            res.data.wxUser.vipExpireTime = setFormateDateEnd(item.validityTime);
          }
          if (item.vipType == 3) {
            const expireDate = setFormateDateEnd(item.validityTime);
            res.data.wxUser.createPostExpireTime = expireDate;
            res.data.wxUser.createPostIsVip =
              now < new Date(item.validityTime).getTime() / 1000 ? 1 : 0;
          }
          return item;
        });

        this.userinfo = res.data.wxUser;
        this.loading = false;
        this.$store.commit('setUserinfo', res.data.wxUser);
        this.isDialogShow();

        const ycUserinfos = JSON.parse(window.localStorage.getItem('ycUserinfos'));
        if (ycUserinfos && ycUserinfos.userName) {
          yichenLoginEx(ycUserinfos).then(result => {
            ycUserinfos.grade = result.data.grade;
            window.localStorage.setItem('ycUserinfos', JSON.stringify(ycUserinfos));
          });
        }
      });
    },
    isDialogShow() {
      this.vipPost = this.$route.path == '/createPost/list';
      if (
        this.userinfo &&
        ((!this.vipPost && this.userinfo.isReceive == 0) ||
          (this.vipPost && this.userinfo.isReceiveFt == 0))
      ) {
        this.show = true;
      }
    },
    backvip() {
      const fetchVip = this.vipPost ? getFreeFTVip : getFreeVip;

      fetchVip().then(() => {
        this.getUserinfo();
        this.$toast('恭喜您领取成功！');
        this.show = false;
      });
    },
  },
};
</script>

<style scoped>
.vipimgbox {
  position: relative;
  width: 330px;
}

.vipimgbox img {
  display: block;
  width: 100%;
  height: auto;
}

.vipimgbox .btn {
  width: 200px;
  height: 40px;
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
}

.vipimgbox .close {
  width: 30px;
  height: 30px;
  position: absolute;
  bottom: 0;
  left: 53%;
  transform: translateX(-50%);
}

.vip15day .btn {
  bottom: 72px;
}

.vip15day .close {
  bottom: 28px;
}
</style>
